module.exports = __webpack_public_path__ + "static/media/lastButton.3b5f2604.svg";